import { HelpCircle } from "lucide-react";
import { useTranslation } from "react-i18next";

// Tiny "?" icon that opens the in-app user-guide drawer pre-scrolled to a
// specific anchor. Plumbing uses a DOM CustomEvent so this component stays
// dependency-free — anyone (including outside the React tree) can dispatch
// `open-user-guide` and the panel will respond.
//
// Usage:
//   <HelpIconButton anchor="ch2" />
//
// Anchor values must match an id used by UserGuidePanel's TOC, e.g.
//   intro · ch1 · ch2 · ch3 · ch4 · ch5 · glossary · faq
export default function HelpIconButton({ anchor = "intro", testId, size = 14, className = "", label }) {
  const { t } = useTranslation();
  const title = label || t("actions.helpForTab", { defaultValue: "Open user guide" });
  return (
    <button
      type="button"
      onClick={() => window.dispatchEvent(new CustomEvent("open-user-guide", { detail: { anchor } }))}
      data-testid={testId || `help-icon-${anchor}`}
      className={
        "inline-flex items-center justify-center text-gray-400 hover:text-[#002FA7] " +
        "transition-colors p-1 -m-1 align-middle " + className
      }
      title={title}
      aria-label={title}
    >
      <HelpCircle size={size} strokeWidth={2} />
    </button>
  );
}
